import React, {Component} from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {Area, AreaChart, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid, Legend} from "recharts";

import * as overviewActions from "../../actions/overview";
import * as vignetsActions from "../../actions/vignets";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import {Modal, ModalBody, ModalFooter, Button} from 'reactstrap';
import Loader from "react-loader-spinner";

import * as graphMethods from '../../lib/graph';
var dateFormat = require('dateformat');

class Analytics extends Component {

    constructor(props) {
        super(props);

        var toDate = new Date();
        var fromDate = new Date();


        fromDate.setDate(toDate.getDate() - 32);


        this.state = {
            value: '',
            graphDuration: this.props.match.params.id ? 'month' : 'day',
            fromDate: fromDate.toLocaleDateString("en-US"),
            toDate: toDate.toLocaleDateString("en-US"),
            graphData : undefined,
            showGraphMessage : false,
            selectedDateIndex : '0'

        };
        this.setGraphDuration = this.setGraphDuration.bind(this);
        this.applyDatepicker = this.applyDatepicker.bind(this);
        this.toggle = this.toggle.bind(this);


    }

    componentDidMount() {
        this.getGraphData(this.state.graphDuration);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props !== nextProps || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.overviewData.dashboardGraph !== prevProps.overviewData.dashboardGraph || this.props.vignetsData.graphData !== prevProps.vignetsData.graphData) {
            console.log(this.props.match.params.id);

            console.log(this.props.overviewData.dashboardGraph);
            if(this.props.match.params.id !== undefined){
                var dashboardGraph = this.props.vignetsData.graphData;
            }
            else{
                var dashboardGraph = this.props.overviewData.dashboardGraph;
            }
            this.setState({ dashboardGraph : dashboardGraph, graphData : dashboardGraph });

            let startDate = this.state.fromDate;
            let endDate = this.state.toDate;

            let noOfDays = ((new Date(endDate) - new Date(startDate))  /(1000*60*60*24))+1;

            if (this.state.graphDuration === 'hour') {
                for (let [key, value] of graphMethods.fillEmptyValues(this.state.fromDate, this.state.toDate, this.state.graphDuration)) {
                    let this_date = new Date(key);
                    let this_key = graphMethods.getFormattedDate(this_date,'Ymd', '-');
                    console.log(this_key);
                    console.log(value);
                    dashboardGraph[this_key] = (dashboardGraph[this_key]) ? dashboardGraph[this_key] : [];
                    dashboardGraph[this_key][value] = dashboardGraph[this_key][value] ? graphMethods.addNewField(dashboardGraph[this_key][value], value, this.state.graphDuration)  :{'page_views':0, 'vignet_views' : 0, 'name' : value};
                }
            }
            else if (this.state.graphDuration === 'day') {

                let this_date = new Date(startDate);
                for (let day = 1; day <= noOfDays; day++) {
                    //let this_key = getFormattedDate(this_date);

                    let this_key = graphMethods.getFormattedDate(this_date, 'Ymd', '-');
                    let xLabel = graphMethods.getFormattedDate(this_date, 'MdY', '');

                    dashboardGraph[this_key] = dashboardGraph[this_key] ? graphMethods.addNewField(dashboardGraph[this_key], xLabel, this.state.graphDuration)  : { 'vignet_views' : 0, 'page_views':0, 'day': this_key, 'name' : xLabel };

                    let nextDate = graphMethods.getNextDate(this_date , 1);
                    this_date = nextDate;
                }
                dashboardGraph = Object.values(dashboardGraph);

            }
            else if (this.state.graphDuration === 'week' ) {


                let summaryRes = [];

                for (let [key , value ] of graphMethods.formatJsonAsGraph(dashboardGraph)) {
                    summaryRes[key] = value;
                }

                dashboardGraph = summaryRes;

            }
            else if (this.state.graphDuration === 'month' ) {


                let summaryRes = [];

                for (let [key , value ] of graphMethods.formatJsonAsGraph(dashboardGraph)) {
                    summaryRes[key] = value;
                }

                dashboardGraph = summaryRes;

                let thisDate = new Date(startDate);
                let toDate = new Date(endDate);


                let currentMonth = thisDate.getMonth();
                let currentYear = thisDate.getFullYear();
                let toYear = toDate.getFullYear();

                let noOfMonths = graphMethods.getNoOfMonthsInBetween(startDate, endDate);

                for (let monthNo = 1; monthNo <= noOfMonths; monthNo++) {
                    //let this_key = getFormattedDate(this_date);

                    if(currentYear <=toYear) {
                        let keyDate = new Date(Date.UTC(currentYear,currentMonth,'1','0','0','0'));
                        let this_key = keyDate.getTime();

                        let xLabel = graphMethods.getFormattedMonth(currentMonth, currentYear);



                        dashboardGraph[this_key] = dashboardGraph[this_key] ? graphMethods.addNewField(dashboardGraph[this_key], xLabel, this.state.graphDuration)  : { 'vignet_views' : 0, 'page_views':0, 'month': this_key, 'name' : xLabel };

                        if(currentMonth === 12) {
                            currentMonth = 1;
                            currentYear++;
                        }
                        currentMonth++;
                    }

                }

                dashboardGraph =  dashboardGraph.sort(graphMethods.sortByKey("month"));
            }

            else if (this.state.graphDuration === 'year') {

                let summaryRes = [];

                for (let [key , value ] of graphMethods.formatJsonAsGraph(dashboardGraph)) {
                    summaryRes[key] = value;
                }

                dashboardGraph = summaryRes;

                let currentDate = new Date(startDate);
                let endDate = new Date(endDate);


                let currentYear = currentDate.getFullYear();
                let endYear = endDate.getFullYear();

                for (let year = currentYear; year <= endYear; year++) {
                    //let this_key = getFormattedDate(this_date);
                    let xLabel = currentYear;
                    dashboardGraph[currentYear] = dashboardGraph[currentYear] ? graphMethods.addNewField(dashboardGraph[currentYear], xLabel, this.state.graphDuration)  : { 'vignet_views' : 0, 'page_views':0, 'year': currentYear, 'name' : xLabel };
                }
            }

            this.setState({ dashboardGraph : dashboardGraph },function() {  this.setCurrentGraph(0);});

        }

    }


    setCurrentGraph(index) {
        this.setState({"selectedDateIndex" : index});
        let graphData = [];
        if(this.state.graphDuration === 'hour') {
            let graphDates = this.state.graphDates;

            let hourDataSet = this.state.dashboardGraph[graphDates[index].name] ? this.state.dashboardGraph[graphDates[index].name]:[];

            let graphEntries = Object.values(hourDataSet);

            graphData = graphEntries.sort(function(a,b) {
                return a.name - b.name
            });
        }
        else if(this.state.graphDuration === 'day') {

            graphData = this.state.dashboardGraph;
        }
        else if( this.state.graphDuration === 'week' || this.state.graphDuration === 'month' || this.state.graphDuration === 'year') {

            graphData = Object.values(this.state.dashboardGraph);
        }

        this.setState({ graphData : graphData });

    }


    setGraphDuration(duration) {
        this.setState({ graphData : undefined });
        let startDate = new Date(this.state.fromDate);
        let endDate = new Date(this.state.toDate);
        let diff = (endDate-startDate) / (1000 * 60 * 60 *24);

        let graphDates = [];

        if(duration === 'hour' && diff > 6) {
            // Max 7 days
            endDate = startDate.addDays(6);
            this.setState({
                showGraphMessage: !this.state.showGraphMessage,
                alertMessage : 'Since the graph type is hour, we are restring the end date to be within 7 days'
            });
        }
        if(duration === 'hour') {
            let startDate = new Date(this.state.fromDate);
            let nextDate = startDate;
            var options = { year: 'numeric', month: 'short', day: 'numeric' };

            for(let i=0; i<7;i++) {
                let formattedDate = nextDate.getFullYear()+ "-"+ String(nextDate.getMonth()+1).padStart(2,0) +"-"+ String(nextDate.getDate()).padStart(2,0);
                graphDates.push({ name: formattedDate, value: nextDate.toLocaleDateString("en-US", options)});
                nextDate = nextDate.addDays(1);
            }

            this.setState({graphDates : graphDates });

        }




        this.setState({graphDuration: duration, toDate : endDate.toLocaleDateString("en-US")});
        this.getGraphData(duration,startDate.toLocaleDateString("en-US"),endDate.toLocaleDateString("en-US"));
    }

    getVigProps(vigId, itemIndex, section_name) {
        let data = {vignet_id: vigId, section: 'overview', index: itemIndex, section_name: section_name};
        // console.log(data)
        this.props.allVignetsProps(data);
        // console.log(this.props.vignetsData.vignetProps);
    }

    applyDatepicker(event, picker) {
        this.setState({
            'fromDate': picker.startDate._d.toLocaleDateString("en-US"),
            'toDate': picker.endDate._d.toLocaleDateString("en-US")
        });
        this.getGraphData(this.state.graphDuration);
    }

    getGraphData(duration, fromDate, toDate) {
        /*console.log(this.props.match.params.id)
        let data = {type: duration, fromDate: ( fromDate ? fromDate : this.state.fromDate), toDate: ( toDate ? toDate : this.state.toDate)};
        this.props.dashboardGraphData(data);*/
        if(this.props.match.params.id === undefined){
            let data = {type: duration, fromDate: ( fromDate ? fromDate : this.state.fromDate), toDate: ( toDate ? toDate : this.state.toDate)};
            this.props.dashboardGraphData(data);
        }
        else{
            let data = {vignet_id: this.props.match.params.id, type: duration, fromDate: ( fromDate ? fromDate : this.state.fromDate), toDate: ( toDate ? toDate : this.state.toDate)};
            this.props.vignetGraphData(data);
        }
    }

    toggle() {
        this.setState({
            showGraphMessage: !this.state.showGraphMessage,
            alertMessage : ''
        });
    }


    render() {
        return (

                <div className="tab__panel tab_scroll">
                    <div className="tab-head">
                        <h5>PAGE VIEWS / VISITS - <span className="font-bold">{this.state.fromDate ? dateFormat(this.state.fromDate,"d mmm yyyy").toUpperCase() :'' } - {this.state.toDate ? dateFormat(this.state.toDate,"d mmm yyyy").toUpperCase() :'' }</span>
                        </h5>
                        <DateRangePicker startDate={this.state.fromDate} endDate={this.state.toDate}
                                         onApply={this.applyDatepicker}>
                            <button>{this.state.fromDate} - {this.state.toDate}</button>
                        </DateRangePicker>
                    </div>
                    <div className="graph-headr">
                        <div className="btn-group" role="group" aria-label="Basic example">
                            <button type="button" className={"btn btn-secondary btn-bgcolor" + (this.state.graphDuration=== 'hour'? ' active' :'' )}
                                    onClick={() => this.setGraphDuration('hour')}>Hour
                            </button>
                            <button type="button" className={"btn btn-secondary btn-bgcolor" + (this.state.graphDuration=== 'day'? ' active' :'' )}
                                    onClick={() => this.setGraphDuration('day')}>Day
                            </button>
                            <button type="button" className={"btn btn-secondary btn-bgcolor" + (this.state.graphDuration=== 'week'? ' active' :'' )}
                                    onClick={() => this.setGraphDuration('week')}>Week
                            </button>
                            <button type="button" className={"btn btn-secondary btn-bgcolor" + (this.state.graphDuration=== 'month'? ' active' :'' )}
                                    onClick={() => this.setGraphDuration('month')}>Month
                            </button>
                            <button type="button" className={"btn btn-secondary btn-bgcolor" + (this.state.graphDuration=== 'year'? ' active' :'' )}
                                    onClick={() => this.setGraphDuration('year')}>Year
                            </button>
                        </div>
                    </div>
                    <div className="graph-plot">

                        {!this.state.graphData &&
                        <div className="loaderWrapper">
                            <Loader type="ThreeDots" color="#54A1D7"  height="50" width="50"/>
                        </div>
                        }
                        {this.state.graphData &&
                        <ResponsiveContainer width="100%" height={380} aspect="width">


                            <AreaChart data={this.state.graphData}
                                       margin={{top: 10, right: 30, left: 0, bottom: 0}}>
                                <defs>
                                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#dff3fc" stopOpacity={0.8}/>
                                        <stop offset="95%" stopColor="#dff3fc" stopOpacity={0}/>
                                    </linearGradient>
                                    <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#ecddef" stopOpacity={0.8}/>
                                        <stop offset="95%" stopColor="#ecddef" stopOpacity={0}/>
                                    </linearGradient>
                                    <linearGradient id="colorVv" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#ecddef" stopOpacity={0.8}/>
                                        <stop offset="95%" stopColor="#ecddef" stopOpacity={0}/>
                                    </linearGradient>
                                </defs>
                                <XAxis  dataKey="name" tick={{fontSize: 12}}/>
                                <YAxis tick={{fontSize: 12}}/>
                                <CartesianGrid stroke="#f5f5f5" vertical={false}/>
                                <Tooltip/>
                                <Legend verticalAlign="bottom" height={36} iconType={"square"} iconSize={"10"}/>
                                <Area name="Page Views" type="monotone" dataKey="page_views" stroke="#45ace3" fillOpacity={1}
                                      fill="url(#colorUv)"/>
                                <Area name="Nugget Views" type="monotone" dataKey="vignet_views" stroke="#eac2e4" fillOpacity={1}
                                      fill="url(#colorPv)"/>
                                <Area name="User Views" type="monotone" dataKey="user_views" stroke="#eac234" fillOpacity={1}
                                      fill="url(#colorVv)"/>
                            </AreaChart>
                        </ResponsiveContainer>
                        }
                        <div role="toolbar" aria-label="Toolbar with button groups">
                            <div className="btn-group mr-2" role="group" aria-label="First group">
                                { this.state.graphDates && this.state.graphDuration=== 'hour' &&
                                this.state.graphDates.map((entry, index) => <button type="button" className={"btn btn-secondary btn-bgcolor" + (this.state.selectedDateIndex === index   ? ' active' :'' )} onClick={()=>this.setCurrentGraph(index)}>{entry.value}</button>)
                                }
                            </div>
                        </div>
                    </div>

                    {this.state.showGraphMessage &&
                    <Modal isOpen={this.state.showGraphMessage} id="pl-message">
                        <ModalBody>
                            <div className="alert alert-default text-center" role="alert">
                                {this.state.alertMessage}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.toggle}>Close</Button>
                        </ModalFooter>
                    </Modal>
                    }
                </div>
        )
    }

}

function mapStateToProps(state) {
    return {
        overviewData: state.overview.overviewData,
        vignetsData  :state.vignets.vignetsData,
    };

}

export default withRouter(connect(mapStateToProps, {
    dashboardGraphData: overviewActions.getGraphData,
    vignetGraphData : vignetsActions.fetchGraphData,
    allVignetsProps: vignetsActions.getVignetProps
})(Analytics));



// WEBPACK FOOTER //
// ./src/components/common/Analytics.js